import { AnchorModel, Link } from '@bpba/ui-components';

export enum TipoProducto {
  FISICO = 1,
  VOUCHER = 2,
  SOLIDARIDAD = 3,
  SMILES = 4,
  CDNI = 5,
  CHANCE = 6,
}

export class ProductoData extends AnchorModel {
  id: number;
  descripcion: string;
  puntos: number;
  codigo: string;
  destacado: boolean;
  tipoProducto: TipoProducto;
  rubroTitle: string;
  imagenes: string[];
  stock?: number;
  iconoRubro?: string;
  descripcionDetallada?: string;
  productosRelacionados?: [ProductoData];
  descuento?: string;
  linkLocales?: Link;
  rubroId: string;
  productoId: string;

  constructor(
    id: number,
    orden: number,
    titulo: string,
    descripcion: string,
    puntos: number,
    codigo: string,
    destacado: boolean,
    tipoProducto: TipoProducto,
    rubroTitle: string,
    imagenes: string[],
    rubroId: string,
    productoId: string,
    enlace?: Link,
    stock?: number,
    iconoRubro?: string,
    descripcionDetallada?: string,
    productosRelacionados?: [ProductoData],
    descuento?: string,
    link?: Link
  ) {
    super(orden, titulo, enlace, undefined);
    this.id = id;
    this.descripcion = descripcion;
    this.puntos = puntos;
    this.destacado = destacado;
    this.codigo = codigo;
    this.tipoProducto = tipoProducto;
    this.rubroTitle = rubroTitle;
    this.imagenes = imagenes;
    this.stock = stock;
    this.iconoRubro = iconoRubro;
    this.descripcionDetallada = descripcionDetallada;
    this.productosRelacionados = productosRelacionados;
    this.descuento = descuento;
    this.linkLocales = link;
    this.rubroId = rubroId;
    this.productoId = productoId;
  }

  esVoucher(): boolean {
    return this.tipoProducto === TipoProducto.VOUCHER || this.tipoProducto === TipoProducto.CDNI;
  }

  esFisico(): boolean {
    return this.tipoProducto === TipoProducto.FISICO;
  }

  esSolidaridad(): boolean {
    return this.tipoProducto === TipoProducto.SOLIDARIDAD;
  }

  esProgramaSmiles(): boolean {
    return this.tipoProducto === TipoProducto.SMILES;
  }

  /** Decrementa el stock del producto en una unidad */
  actualizarStock() {
    if (this.stock) this.stock -= 1;
  }
}
